module.exports = __webpack_public_path__ + "img/satellite-dish.2c3a09e0.svg";